import React from 'react'

// eslint-disable-next-line no-unused-vars
import { ITableContext } from '../interfaces/table'

export const TableContext = React.createContext<ITableContext>({
  columns: [],
  currentColumns: [],
  setCurrentColumns: () => {},
  data: [],
  currentData: [],
  setCurrentData: () => {}
})
